import React, { useCallback } from 'react'
import BenefitBanner from '~/app/components-nds/common/benefit-banner'
import { MessageBox } from '@yanolja-rnd/nol-design-system'
import { getYaNative } from '@yanolja-rnd/ya-native'
import { isNative } from '~/app/utils/typeguards'
import { sendKinesisClickLogTimeoutAfter } from '~/app/utils/timeout'
import { sendKinesisBannerClick } from '~/app/kinesis/cart-page'
import { sendKinesisBannerImpr } from '~/app/kinesis/cart-page'
import { DomesticCartBenefitBanner } from '~/api/converters/domestic/cart/BenefitBanner/index.type'

// TODO: (닥터) DomesticCartConverterResponse 에 따라 CartBannerGuideProps 수정 필요할 수 있음

const CartBannerGuide = ({ image, action, logMeta }: DomesticCartBenefitBanner) => {
  const onBannerClick = useCallback(async () => {
    if (!action) return

    const { id, objectType, title } = logMeta || {}
    const yaNative = getYaNative()
    const isNativeEnv = isNative(yaNative)

    const link = isNativeEnv ? action.app : action.web
    if (!link) return

    const navigateAction = isNativeEnv
      ? () => yaNative.deepLink({ link })
      : () => {
          window.location.href = link
        }

    try {
      if (id && objectType && title && link) {
        await sendKinesisClickLogTimeoutAfter(() =>
          sendKinesisBannerClick(id, objectType, title, link)
        )
      }
    } catch (error) {
      console.error('배너 클릭 처리 중 에러 발생:', error)
    } finally {
      navigateAction()
    }
  }, [action, logMeta])

  const onBannerImpressed = useCallback(() => {
    if (!logMeta) return
    const { id, objectType, title } = logMeta
    sendKinesisBannerImpr(id, objectType, title)
  }, [logMeta])

  return (
    <div className={'flex w-full flex-col gap-16 bg-static-white pc:gap-20'}>
      {image && (
        <BenefitBanner url={image} onImpressed={onBannerImpressed} onClick={onBannerClick} />
      )}
      <MessageBox theme="info" align="left" type="multiple" className="pc:px-16 pc:py-12">
        <ul className="flex flex-col gap-8 px-16 typography-body-13-regular-multiline">
          <li className="list-disc">
            장바구니에 담은 상품은 최대 30일간 보관되고 최대 20개까지 담을 수 있어요.
          </li>
          <li className="list-disc">
            장바구니에서 수량 및 상세 옵션을 변경할 수 없는 상품도 있어요. 삭제 후 다시 담아주세요.
          </li>
          <li className="list-disc">
            쿠폰 및 포인트가 적용된 최종 결제 금액은 다를 수 있으므로 예약화면에서 확인해 주세요.
          </li>
        </ul>
      </MessageBox>
    </div>
  )
}

export default CartBannerGuide
